import { css } from '@emotion/react';
import { countStaticStyle as tagCountStaticStyle } from '../tag/styles';
import { theme } from '../theme';
import { tokens } from '../tokens';
const sizeMap = {
    large: {
        iconSize: '18px',
        offset: tokens.sizing.large,
        spacing: tokens.spacingNew.medium,
    },
    medium: {
        iconSize: '16px',
        offset: tokens.sizing.medium,
        spacing: tokens.spacingNew.small,
    },
    small: {
        iconSize: '14px',
        offset: tokens.sizing.small,
        spacing: tokens.spacingNew.xsmall,
    },
};
export const wrapperStaticStyle = css({
    flexGrow: 1,
    width: '100%',
});
const buttonWrapperStaticStyle = css({
    background: theme.background.transparent,
    borderRadius: '6px',
    display: 'inline-flex',
    listStyle: 'none',
    maxWidth: 'inherit',
});
const buttonWrapperFullWidthStaticStyle = css({
    display: 'grid',
    gridAutoColumns: 'minmax(min-content, 1fr)',
    gridAutoFlow: 'column',
    whiteSpace: 'nowrap',
    width: '100%',
});
export function buttonWrapperStyle({ fullWidth, hasDividers, }) {
    return [
        buttonWrapperStaticStyle,
        css({
            gap: hasDividers
                ? `calc(${tokens.spacingNew.xsmall} - ${tokens.borderWidth.thin})`
                : tokens.spacingNew.tiny,
        }),
        ...(fullWidth ? [buttonWrapperFullWidthStaticStyle] : []),
    ];
}
const buttonDividerStyle = css({
    '&:not(:last-child):not([aria-current]):not(:has(+ [aria-current]))::after': {
        background: theme.border.main,
        content: '""',
        height: `calc(100% - ${tokens.spacingNew.xsmall})`,
        position: 'absolute',
        right: `calc(${tokens.spacingNew.tiny} - ${tokens.spacingNew.xsmall})`,
        top: tokens.spacingNew.tiny,
        width: tokens.borderWidth.thin,
    },
});
export function listItemStyle({ hasDividers }) {
    return [
        css({ display: 'inline-flex', position: 'relative' }),
        hasDividers ? [buttonDividerStyle] : [],
    ];
}
const buttonStaticStyle = css({
    color: theme.text.main,
    flexDirection: 'row',
    gap: tokens.spacingNew.xsmall,
});
export function buttonStyle({ fullWidth, hideLabel, isActive, isDropdown, size, variant, }) {
    const isPrimary = variant === 'primary';
    const backgroundColor = isPrimary
        ? theme.background.contrastInverse
        : theme.background.main;
    const hoverBackgroundColor = isPrimary
        ? theme.background.hoverStrongInverse
        : theme.background.hoverStrong;
    return [
        buttonStaticStyle,
        css(Object.assign(Object.assign({}, (fullWidth && { flexGrow: 1 })), (isDropdown && Object.assign({ paddingRight: fullWidth ? sizeMap[size].offset : 0 }, (hideLabel && {
            alignItems: 'center',
            display: 'flex',
            gap: `calc(${sizeMap[size].spacing} - 2px)`,
            paddingLeft: `calc(${sizeMap[size].spacing} - 2px)`,
            svg: {
                height: sizeMap[size].iconSize,
                width: sizeMap[size].iconSize,
            },
        }))))),
        ...(isActive
            ? [
                {
                    ':active': {
                        background: backgroundColor,
                    },
                    ':hover': {
                        '::before': { backgroundColor: hoverBackgroundColor },
                        borderColor: hoverBackgroundColor,
                    },
                    background: backgroundColor,
                    color: isPrimary ? theme.text.inverse : theme.text.main,
                },
            ]
            : []),
    ];
}
const countStaticStyle = css({
    borderRadius: tokens.borderRadius.medium,
    padding: `0 ${tokens.spacingNew.tiny}`,
});
export function countStyle({ isActive }) {
    return [
        countStaticStyle,
        tagCountStaticStyle,
        css({
            background: isActive
                ? theme.background.transparentInverse
                : theme.background.transparent,
        }),
    ];
}
const dropdownTriggerStaticStyle = css({
    alignItems: 'center',
    display: 'inline-flex',
    height: `calc(100% + ${tokens.borderWidth.xthick})`,
});
const dropdownTriggerFullWidthStaticStyle = css({
    position: 'absolute',
    right: 0,
});
export function dropdownTriggerStyle({ fullWidth, hideLabel, size, variant, }) {
    const triggerSpacing = sizeMap[size].spacing;
    return [
        dropdownTriggerStaticStyle,
        css(Object.assign({ borderLeft: `${tokens.borderWidth.thin} solid ${variant === 'primary'
                ? theme.background.transparentInverse
                : theme.background.transparent}`, paddingLeft: `calc(${triggerSpacing} - 2px)`, paddingRight: `calc(${triggerSpacing} - 2px)` }, (!hideLabel && { marginLeft: `calc(${triggerSpacing} / 2)` }))),
        ...(fullWidth ? [dropdownTriggerFullWidthStaticStyle] : []),
    ];
}
